// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlockInfo_wrapper__dvqsV","heading":"BlockInfo_heading__aFc9g","content":"BlockInfo_content__q2688","title":"BlockInfo_title__Ze3a8","accent":"BlockInfo_accent__AnhsG"};